import React, { createContext, useCallback, useState } from "react";
import { clientFetch } from "../utils/clientFetch";
import { ContextFetchResult } from "../types/contextFetchResult";

type MeasurementsErrorType = {
  id: number
  brand_name: string
  error_minus: string
  error_plus: string
  measure_name: string
}

export const MeasurementsErrorContext = createContext<{
  measurementsError: MeasurementsErrorType[]
}>({
  measurementsError: []
})

export const UpdateMeasurementsErrorContext = createContext<{
  refreshMeasurementsError: (id: string) => Promise<ContextFetchResult<MeasurementsErrorType[]>>
}>({
  refreshMeasurementsError: async (_id: string) => ({ status: null, data: null })
})

export function useMeasurementsErrorContext() {
  const [measurementsError, setMeasurementsError] = useState<MeasurementsErrorType[]>([])

  const refreshMeasurementsError = useCallback(async (id: string): Promise<ContextFetchResult<MeasurementsErrorType[]>> => {
    try {

      const res = await clientFetch(`${process.env.REACT_APP_API_ENDPOINT}/apis/admin/measurement-error/${id}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      })

      if (!res.ok) {
        return {
          status: res.status,
          data: null,
        }
      }
      const data = await res.json() as MeasurementsErrorType[];
      setMeasurementsError(data);
      return {
        status: res.status,
        data,
      }
    } catch (error) {
      console.error("Error fetching measurements error.", error);
      return {
        status: null,
        data: null,
      }
    }
  }, [])

  return {
    measurementsError,
    refreshMeasurementsError,
  }
}

export function MeasurementsErrorProvider({ children }: { children: React.ReactNode }) {
  const { measurementsError, refreshMeasurementsError } = useMeasurementsErrorContext()

  return (
    <UpdateMeasurementsErrorContext.Provider value={{ refreshMeasurementsError }}>
      <MeasurementsErrorContext.Provider value={{ measurementsError }}>
        {children}
      </MeasurementsErrorContext.Provider>
    </UpdateMeasurementsErrorContext.Provider>
  )
}
